import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Auth } from 'aws-amplify';


export const resendConfirmationCode = createAsyncThunk(
    'admin/resendConfirmationCode',
    async(username, { rejectWithValue, dispatch }) => {
        try {
            const response = await Auth.resendSignUp(username);
            console.log('code resent successfully');
            return response.data
        } catch (error) {
            console.log('error resending code: ', error);
            return rejectWithValue(error)
        }
    }
)

const adminSlice = createSlice({
    name: 'admin',
    initialState: {
        currentUser: [],
        currentUserSession: [],
        currentUserInfo: [],
        currentUserCredentials: [],
        currentUserGroup: '',
        currentUserName: '',
        currentUserEmail: '',
        currentUserId: '',
        fetchStatus: '',
        error: '',
    },
    reducers: {
        userGroup(state, action) {
            //console.log('State: ', state)
            //console.log('Action: ', action)

            state.currentUserName = action.payload.username
            state.currentUserEmail = action.payload.attributes.email
            state.currentUserId = action.payload.attributes.sub


            if (!action.payload.signInUserSession.idToken.payload["cognito:groups"]) {
                state.currentUserGroup = 'user';
            } else if (
                action.payload.signInUserSession.idToken.payload["cognito:groups"][0] === "Admin"
            ) {
                state.currentUserGroup = 'admin';
            } else {
                state.currentUserGroup = 'user';
            }
        },

        getCurrentUser(state, action) {
            try {
                const user = Auth.currentAuthenticatedUser({ bypassCache: true })
                console.log("GET CURRENT AUTH USER")
                return user
            } catch (error) {
                console.log('error resending code: ', error);
                //return rejectWithValue(error)
            }

        },

        extraReducers: {
            [resendConfirmationCode.pending]: (state, action) => {
                state.fetchStatus = 'loading';
                state.error = null;
            },
            [resendConfirmationCode.fulfilled]: (state, action) => {
                state.fetchStatus = 'loaded'
                state.error = null;
            },
            [resendConfirmationCode.rejected]: (state, action) => {
                state.fetchStatus = 'rejected';
                state.error = action.payload
                console.log("ERRORRRRR", action.payload)
            },
            

        }
    },
});

export const { userGroup, getCurrentUser } = adminSlice.actions;
export default adminSlice.reducer;